export const FINANCIAL_COCKPIT_NAMESPACE = 'jbp-financial-cockpit'

// i18n key registry for the financial cockpit feature. Grouped by UI region as content
// is built out (mirrors mdfActivities/configs/translations.ts).
export const FINANCIAL_COCKPIT_TRANSLATION_KEYS = {
  title: `${FINANCIAL_COCKPIT_NAMESPACE}-title`,
  greeting: {
    reportIssue: `${FINANCIAL_COCKPIT_NAMESPACE}-greeting-report-issue`,
    role: `${FINANCIAL_COCKPIT_NAMESPACE}-greeting-role`,
    accessLevel: `${FINANCIAL_COCKPIT_NAMESPACE}-greeting-access-level`,
    rtm: `${FINANCIAL_COCKPIT_NAMESPACE}-greeting-rtm`,
    offerings: `${FINANCIAL_COCKPIT_NAMESPACE}-greeting-offerings`,
    roles: {
      P360PartnerManager: `${FINANCIAL_COCKPIT_NAMESPACE}-greeting-role-pbm`,
      P360SalesManager: `${FINANCIAL_COCKPIT_NAMESPACE}-greeting-role-manager`,
      P360GeoLead: `${FINANCIAL_COCKPIT_NAMESPACE}-greeting-role-market-lead`,
    },
  },
  tabs: {
    cockpit: `${FINANCIAL_COCKPIT_NAMESPACE}-tab-cockpit`,
    topPartners: `${FINANCIAL_COCKPIT_NAMESPACE}-tab-top-partners`,
    myPartners: `${FINANCIAL_COCKPIT_NAMESPACE}-tab-my-partners`,
    businessPriorities: `${FINANCIAL_COCKPIT_NAMESPACE}-tab-business-priorities`,
    marketYoyTargets: `${FINANCIAL_COCKPIT_NAMESPACE}-tab-market-yoy-targets`,
    strategicInitiatives: `${FINANCIAL_COCKPIT_NAMESPACE}-tab-strategic-initiatives`,
    coverageReport: `${FINANCIAL_COCKPIT_NAMESPACE}-tab-coverage-report`,
  },
  export: {
    tooltip: `${FINANCIAL_COCKPIT_NAMESPACE}-export-tooltip`,
    error: `${FINANCIAL_COCKPIT_NAMESPACE}-export-error`,
  },
  downloadProgress: {
    requesting: {
      title: `${FINANCIAL_COCKPIT_NAMESPACE}-download-progress-requesting-title`,
      description: `${FINANCIAL_COCKPIT_NAMESPACE}-download-progress-requesting-description`,
    },
    processing: {
      title: `${FINANCIAL_COCKPIT_NAMESPACE}-download-progress-processing-title`,
      description: `${FINANCIAL_COCKPIT_NAMESPACE}-download-progress-processing-description`,
    },
    downloading: {
      title: `${FINANCIAL_COCKPIT_NAMESPACE}-download-progress-downloading-title`,
      description: `${FINANCIAL_COCKPIT_NAMESPACE}-download-progress-downloading-description`,
    },
    error: {
      title: `${FINANCIAL_COCKPIT_NAMESPACE}-download-progress-error-title`,
      description: `${FINANCIAL_COCKPIT_NAMESPACE}-download-progress-error-description`,
      tryAgain: `${FINANCIAL_COCKPIT_NAMESPACE}-download-progress-error-try-again`,
    },
  },
  revenueAndSob: {
    tileTitle: `${FINANCIAL_COCKPIT_NAMESPACE}-revenue-and-sob-title`,
    sales: `${FINANCIAL_COCKPIT_NAMESPACE}-revenue-and-sob-sales`,
    sob: `${FINANCIAL_COCKPIT_NAMESPACE}-revenue-and-sob-sob`,
    // The `{fy}` param is the two-digit financial year, e.g. `26`.
    baseline: `${FINANCIAL_COCKPIT_NAMESPACE}-revenue-and-sob-baseline`,
    // The baseline's title while that year is still in its last quarter: `FY{fy} YTD`.
    ytd: `${FINANCIAL_COCKPIT_NAMESPACE}-revenue-and-sob-ytd`,
    plan: `${FINANCIAL_COCKPIT_NAMESPACE}-revenue-and-sob-plan`,
    expectedExit: `${FINANCIAL_COCKPIT_NAMESPACE}-revenue-and-sob-expected-exit`,
    actuals: `${FINANCIAL_COCKPIT_NAMESPACE}-revenue-and-sob-actuals`,
    quota: `${FINANCIAL_COCKPIT_NAMESPACE}-revenue-and-sob-quota`,
    category: `${FINANCIAL_COCKPIT_NAMESPACE}-revenue-and-sob-category`,
    total: `${FINANCIAL_COCKPIT_NAMESPACE}-revenue-and-sob-total`,
    lowestGrowthTitle: `${FINANCIAL_COCKPIT_NAMESPACE}-revenue-and-sob-lowest-growth-title`,
    lowestGrowthVsMarket: `${FINANCIAL_COCKPIT_NAMESPACE}-revenue-and-sob-lowest-growth-vs-market`,
    lowestGrowthEmpty: `${FINANCIAL_COCKPIT_NAMESPACE}-revenue-and-sob-lowest-growth-empty`,
    columnOrderProductGeo: `${FINANCIAL_COCKPIT_NAMESPACE}-revenue-and-sob-column-order-product-geo`,
    columnOrderGeoProduct: `${FINANCIAL_COCKPIT_NAMESPACE}-revenue-and-sob-column-order-geo-product`,
    product: `${FINANCIAL_COCKPIT_NAMESPACE}-revenue-and-sob-product`,
    geo: `${FINANCIAL_COCKPIT_NAMESPACE}-revenue-and-sob-geo`,
    offering: `${FINANCIAL_COCKPIT_NAMESPACE}-revenue-and-sob-offering`,
    unmappedGeo: `${FINANCIAL_COCKPIT_NAMESPACE}-revenue-and-sob-unmapped-geo`,
    noRowsAtLevel: `${FINANCIAL_COCKPIT_NAMESPACE}-revenue-and-sob-no-rows-at-level`,
  },
  keyInitiatives: {
    empty: `${FINANCIAL_COCKPIT_NAMESPACE}-key-initiatives-empty`,
    selectOffering: `${FINANCIAL_COCKPIT_NAMESPACE}-key-initiatives-select-offering`,
    tabs: {
      initiatives: `${FINANCIAL_COCKPIT_NAMESPACE}-key-initiatives-tab-initiatives`,
      mdf: `${FINANCIAL_COCKPIT_NAMESPACE}-key-initiatives-tab-mdf`,
      quality: `${FINANCIAL_COCKPIT_NAMESPACE}-key-initiatives-tab-plan-quality`,
    },
    mdf: {
      empty: `${FINANCIAL_COCKPIT_NAMESPACE}-key-initiatives-mdf-empty`,
      totals: {
        planned: `${FINANCIAL_COCKPIT_NAMESPACE}-key-initiatives-mdf-total-planned`,
        requested: `${FINANCIAL_COCKPIT_NAMESPACE}-key-initiatives-mdf-total-requested`,
        paid: `${FINANCIAL_COCKPIT_NAMESPACE}-key-initiatives-mdf-total-paid`,
      },
      showChart: `${FINANCIAL_COCKPIT_NAMESPACE}-key-initiatives-mdf-show-chart`,
      hideChart: `${FINANCIAL_COCKPIT_NAMESPACE}-key-initiatives-mdf-hide-chart`,
      chartLimitSummary: `${FINANCIAL_COCKPIT_NAMESPACE}-key-initiatives-mdf-chart-limit-summary`,
      chartOther: `${FINANCIAL_COCKPIT_NAMESPACE}-key-initiatives-mdf-chart-other`,
      table: {
        requested: `${FINANCIAL_COCKPIT_NAMESPACE}-key-initiatives-mdf-table-requested`,
        paid: `${FINANCIAL_COCKPIT_NAMESPACE}-key-initiatives-mdf-table-paid`,
        sales: `${FINANCIAL_COCKPIT_NAMESPACE}-key-initiatives-mdf-table-sales`,
        contra: `${FINANCIAL_COCKPIT_NAMESPACE}-key-initiatives-mdf-table-contra`,
        activities: `${FINANCIAL_COCKPIT_NAMESPACE}-key-initiatives-mdf-table-activities`,
      },
    },
    openPlan: {
      title: `${FINANCIAL_COCKPIT_NAMESPACE}-key-initiatives-open-plan-title`,
      description: `${FINANCIAL_COCKPIT_NAMESPACE}-key-initiatives-open-plan-description`,
    },
    summary: {
      initiatives: `${FINANCIAL_COCKPIT_NAMESPACE}-key-initiatives-summary-initiatives`,
      financialGoal: `${FINANCIAL_COCKPIT_NAMESPACE}-key-initiatives-summary-financial-goal`,
      incrementalGoal: `${FINANCIAL_COCKPIT_NAMESPACE}-key-initiatives-summary-incremental-goal`,
      mdfPlanned: `${FINANCIAL_COCKPIT_NAMESPACE}-key-initiatives-summary-mdf-planned`,
    },
    table: {
      goal: `${FINANCIAL_COCKPIT_NAMESPACE}-key-initiatives-table-goal`,
      incremental: `${FINANCIAL_COCKPIT_NAMESPACE}-key-initiatives-table-incremental`,
      mdfPlanned: `${FINANCIAL_COCKPIT_NAMESPACE}-key-initiatives-table-mdf-planned`,
      count: `${FINANCIAL_COCKPIT_NAMESPACE}-key-initiatives-table-count`,
    },
  },
  planQuality: {
    combinedTitle: `${FINANCIAL_COCKPIT_NAMESPACE}-plan-quality-combined-title`,
    title: `${FINANCIAL_COCKPIT_NAMESPACE}-plan-quality-title`,
    // groups
    financial: `${FINANCIAL_COCKPIT_NAMESPACE}-plan-quality-financial`,
    sob: `${FINANCIAL_COCKPIT_NAMESPACE}-plan-quality-sob`,
    overall: `${FINANCIAL_COCKPIT_NAMESPACE}-plan-quality-overall`,

    // The `{score}` param is the formatted plan-quality score, e.g. `85%` (or `--` when unavailable).
    tableTitle: `${FINANCIAL_COCKPIT_NAMESPACE}-plan-quality-table-title`,
    yoy: `${FINANCIAL_COCKPIT_NAMESPACE}-plan-quality-yoy`,
    marketTarget: `${FINANCIAL_COCKPIT_NAMESPACE}-plan-quality-market-target`,
    score: `${FINANCIAL_COCKPIT_NAMESPACE}-plan-quality-score`,
  },
  achievementScore: {
    // The SCORE column each Revenue & SOB group gains once its period has actuals. The group
    // headers themselves reuse the `revenueAndSob` labels.
    score: `${FINANCIAL_COCKPIT_NAMESPACE}-achievement-score-score`,
  },
  programTypes: {
    categoryDropdownLabel: `${FINANCIAL_COCKPIT_NAMESPACE}-program-types-category-dropdown-label`,
    allCategories: `${FINANCIAL_COCKPIT_NAMESPACE}-program-types-all-categories`,
    // The category chip at the end of the programme row. Available params: {category}.
    categoryChip: `${FINANCIAL_COCKPIT_NAMESPACE}-program-types-category-chip`,
    // The caption before a picked category, which then stands in its own blue segment.
    categoryCaption: `${FINANCIAL_COCKPIT_NAMESPACE}-program-types-category-caption`,
    // A programme taken out of the plan: its tab's mark.
    switchedOff: `${FINANCIAL_COCKPIT_NAMESPACE}-program-types-switched-off`,
    // Over the board while a programme is switched on and its data fetched again.
    // Available params: {offering}.
    switchingOn: `${FINANCIAL_COCKPIT_NAMESPACE}-program-types-switching-on`,
    switchingOnHint: `${FINANCIAL_COCKPIT_NAMESPACE}-program-types-switching-on-hint`,
    titles: {
      overall: `${FINANCIAL_COCKPIT_NAMESPACE}-program-types-title-overall`,
    },
    subtitles: {
      overall: `${FINANCIAL_COCKPIT_NAMESPACE}-program-types-subtitle-overall`,
      acknowledged: `${FINANCIAL_COCKPIT_NAMESPACE}-program-types-subtitle-acknowledged`,
      notAcknowledged: `${FINANCIAL_COCKPIT_NAMESPACE}-program-types-subtitle-not-acknowledged`,
      disabled: `${FINANCIAL_COCKPIT_NAMESPACE}-program-types-subtitle-disabled`,
      consolidated: `${FINANCIAL_COCKPIT_NAMESPACE}-program-types-subtitle-consolidated`,
      acknowledgedCount: `${FINANCIAL_COCKPIT_NAMESPACE}-program-types-subtitle-acknowledged-count`,
    },
  },
  /** The line under the programme tabs: the selected programme's planning state in numbers. */
  planningStatus: {
    // Follows the completeness figure: "54% complete", "1 of 4 complete".
    complete: `${FINANCIAL_COCKPIT_NAMESPACE}-planning-status-complete`,
    // Available params: {date}.
    acknowledgedOn: `${FINANCIAL_COCKPIT_NAMESPACE}-planning-status-acknowledged-on`,
    // Overall's acknowledged programmes. Available params: {count}, {total}.
    acknowledgedCount: `${FINANCIAL_COCKPIT_NAMESPACE}-planning-status-acknowledged-count`,
    notAcknowledged: `${FINANCIAL_COCKPIT_NAMESPACE}-planning-status-not-acknowledged`,
    // Stands before `--` when the payload says nothing about the signature.
    acknowledgment: `${FINANCIAL_COCKPIT_NAMESPACE}-planning-status-acknowledgment`,
    planQuality: `${FINANCIAL_COCKPIT_NAMESPACE}-planning-status-plan-quality`,
    // Overall's complete programmes. Available params: {count}, {total}.
    count: `${FINANCIAL_COCKPIT_NAMESPACE}-planning-status-count`,
  },
  period: {
    label: `${FINANCIAL_COCKPIT_NAMESPACE}-period-label`,
    fullYear: `${FINANCIAL_COCKPIT_NAMESPACE}-period-full-year`,
    ytd: `${FINANCIAL_COCKPIT_NAMESPACE}-period-ytd`,
  },
  metrics: {
    label: `${FINANCIAL_COCKPIT_NAMESPACE}-metrics-label`,
  },
  currency: {
    label: `${FINANCIAL_COCKPIT_NAMESPACE}-currency-label`,
    multipleLocalCurrenciesDisabled: 'jbp-partner-currency-multy-local-warning',
  },
  // The scope card in the partner column: the fiscal year in its header, the rest in its rows.
  scopeCard: {
    title: `${FINANCIAL_COCKPIT_NAMESPACE}-scope-card-title`,
    currentYear: `${FINANCIAL_COCKPIT_NAMESPACE}-scope-card-current-year`,
    pastYear: `${FINANCIAL_COCKPIT_NAMESPACE}-scope-card-past-year`,
    // Under the year list: picking a year loads the whole cockpit again.
    reloadNote: `${FINANCIAL_COCKPIT_NAMESPACE}-scope-card-reload-note`,
    // The way back to the latest year, in the card's header while a past year is open.
    // Available params: {year}.
    backToYear: `${FINANCIAL_COCKPIT_NAMESPACE}-scope-card-back-to-year`,
    // Over the board while another year's data is fetched. Available params: {year}.
    loadingYear: `${FINANCIAL_COCKPIT_NAMESPACE}-scope-card-loading-year`,
    loadingYearHint: `${FINANCIAL_COCKPIT_NAMESPACE}-scope-card-loading-year-hint`,
  },
  // The white deck over the board: the year, the offering tabs and the selected plan's state.
  planDeck: {
    completeness: `${FINANCIAL_COCKPIT_NAMESPACE}-plan-deck-completeness`, // Completeness
    acknowledgment: `${FINANCIAL_COCKPIT_NAMESPACE}-plan-deck-acknowledgment`, // Acknowledgment
    planQuality: `${FINANCIAL_COCKPIT_NAMESPACE}-plan-deck-plan-quality`, // Plan quality
    // Overall's caption: the score across the offerings.
    averagePlanQuality: `${FINANCIAL_COCKPIT_NAMESPACE}-plan-deck-average-plan-quality`,
    // After the big percent: "57% completed".
    completed: `${FINANCIAL_COCKPIT_NAMESPACE}-plan-deck-completed`,
    // Overall, after the big count of complete offerings. Available params: {total}.
    ofCompleted: `${FINANCIAL_COCKPIT_NAMESPACE}-plan-deck-of-completed`, // of {total} completed
    // Overall, after the big count of signed offerings. Available params: {total}.
    ofAcknowledged: `${FINANCIAL_COCKPIT_NAMESPACE}-plan-deck-of-acknowledged`, // of {total} acknowledged
    acknowledged: `${FINANCIAL_COCKPIT_NAMESPACE}-plan-deck-acknowledged`, // Acknowledged
    // Under "Acknowledged". Available params: {date}.
    acknowledgedOn: `${FINANCIAL_COCKPIT_NAMESPACE}-plan-deck-acknowledged-on`, // on {date}
    // In place of the state of an offering switched off. Available params: {offering}, {year}.
    switchedOff: `${FINANCIAL_COCKPIT_NAMESPACE}-plan-deck-switched-off`,
    switchedOffHint: `${FINANCIAL_COCKPIT_NAMESPACE}-plan-deck-switched-off-hint`,
    switchOn: `${FINANCIAL_COCKPIT_NAMESPACE}-plan-deck-switch-on`, // Switch on
    // The list behind the "on of all" button after the tabs. Available params: {year}.
    offerings: `${FINANCIAL_COCKPIT_NAMESPACE}-plan-deck-offerings`, // Offerings in {year}
    offeringsNote: `${FINANCIAL_COCKPIT_NAMESPACE}-plan-deck-offerings-note`,
    // Leads the folded deck's line over an expanded tile. Available params: {offering}.
    planOf: `${FINANCIAL_COCKPIT_NAMESPACE}-plan-deck-plan-of`, // {offering} plan:
    pin: `${FINANCIAL_COCKPIT_NAMESPACE}-plan-deck-pin`, // Keep the plan status open
    unpin: `${FINANCIAL_COCKPIT_NAMESPACE}-plan-deck-unpin`, // Fold the plan status
    // Over an open plan section: the button at the end of the strip of tabs at the top of the screen
    // drops the whole deck, and its pin keeps it there.
    show: `${FINANCIAL_COCKPIT_NAMESPACE}-plan-deck-show`, // Show the plan status
    pinOverSection: `${FINANCIAL_COCKPIT_NAMESPACE}-plan-deck-pin-over-section`, // Keep the plan status above the section
    unpinOverSection: `${FINANCIAL_COCKPIT_NAMESPACE}-plan-deck-unpin-over-section`, // Unpin the plan status
    hide: `${FINANCIAL_COCKPIT_NAMESPACE}-plan-deck-hide`, // Hide the plan status
  },
  // The tray's first button, folding the scope and filter column beside the board.
  scopePanel: {
    hideSidebar: `${FINANCIAL_COCKPIT_NAMESPACE}-scope-panel-hide-sidebar`, // Hide scope and filters
    showSidebar: `${FINANCIAL_COCKPIT_NAMESPACE}-scope-panel-show-sidebar`, // Show scope and filters
  },
  // The Executive Sponsor Program on the partner cockpit's top row: its chip and the panel it opens.
  esp: {
    program: `${FINANCIAL_COCKPIT_NAMESPACE}-esp-program`,
    sponsor: `${FINANCIAL_COCKPIT_NAMESPACE}-esp-sponsor`,
    pending: `${FINANCIAL_COCKPIT_NAMESPACE}-esp-pending`,
    about: `${FINANCIAL_COCKPIT_NAMESPACE}-esp-about`,
    nominate: `${FINANCIAL_COCKPIT_NAMESPACE}-esp-nominate`,
    // Available params: {sponsor}, {date}.
    nominationSent: `${FINANCIAL_COCKPIT_NAMESPACE}-esp-nomination-sent`,
    // Available params: {sponsor}, {date}.
    changeRequested: `${FINANCIAL_COCKPIT_NAMESPACE}-esp-change-requested`,
    engagements: `${FINANCIAL_COCKPIT_NAMESPACE}-esp-engagements`,
    engagementsLocked: `${FINANCIAL_COCKPIT_NAMESPACE}-esp-engagements-locked`,
    engagementsNone: `${FINANCIAL_COCKPIT_NAMESPACE}-esp-engagements-none`,
    // Available params: {days}.
    lastEngagement: `${FINANCIAL_COCKPIT_NAMESPACE}-esp-last-engagement`,
    noEngagement: `${FINANCIAL_COCKPIT_NAMESPACE}-esp-no-engagement`,
    log: `${FINANCIAL_COCKPIT_NAMESPACE}-esp-log`,
    // The quarter already has its one engagement. Available params: {quarter}.
    quarterLogged: `${FINANCIAL_COCKPIT_NAMESPACE}-esp-quarter-logged`,
    requestChange: `${FINANCIAL_COCKPIT_NAMESPACE}-esp-request-change`,
    earlier: `${FINANCIAL_COCKPIT_NAMESPACE}-esp-earlier`,
    later: `${FINANCIAL_COCKPIT_NAMESPACE}-esp-later`,
    close: `${FINANCIAL_COCKPIT_NAMESPACE}-esp-close`,
    // The band at the foot of the sponsor column: a line about the program's site and its button.
    portalText: `${FINANCIAL_COCKPIT_NAMESPACE}-help-panel-esp-portal-text`,
    portal: `${FINANCIAL_COCKPIT_NAMESPACE}-help-panel-esp-portal`,
  },
  // The side panel behind "Help & tools", in the new cockpit and the classic one alike.
  helpPanel: {
    trigger: `${FINANCIAL_COCKPIT_NAMESPACE}-help-panel-trigger`,
    // The trigger's word on the partner cockpit's top row, beside the sponsor.
    menu: `${FINANCIAL_COCKPIT_NAMESPACE}-help-panel-menu`,
    title: `${FINANCIAL_COCKPIT_NAMESPACE}-help-panel-title`,
    close: `${FINANCIAL_COCKPIT_NAMESPACE}-help-panel-close`,
    tourText: `${FINANCIAL_COCKPIT_NAMESPACE}-help-panel-tour-text`,
    trainingText: `${FINANCIAL_COCKPIT_NAMESPACE}-help-panel-training-text`,
    offerings: `${FINANCIAL_COCKPIT_NAMESPACE}-help-panel-offerings`,
    // Available params: {count}, {total}.
    offeringsOn: `${FINANCIAL_COCKPIT_NAMESPACE}-help-panel-offerings-on`,
    offeringsHint: `${FINANCIAL_COCKPIT_NAMESPACE}-help-panel-offerings-hint`,
    cockpit: `${FINANCIAL_COCKPIT_NAMESPACE}-help-panel-cockpit`,
    toClassic: `${FINANCIAL_COCKPIT_NAMESPACE}-help-panel-to-classic`,
    toClassicText: `${FINANCIAL_COCKPIT_NAMESPACE}-help-panel-to-classic-text`,
    toNew: `${FINANCIAL_COCKPIT_NAMESPACE}-help-panel-to-new`,
    toNewText: `${FINANCIAL_COCKPIT_NAMESPACE}-help-panel-to-new-text`,
    // The switch between the plan sections bar pinned under the cockpit and the tabs below it.
    sectionsDock: `${FINANCIAL_COCKPIT_NAMESPACE}-help-panel-sections-dock`,
    sectionsDockText: `${FINANCIAL_COCKPIT_NAMESPACE}-help-panel-sections-dock-text`,
    // Over the panel in the classic cockpit, where only the way back to the new one works.
    classicNote: `${FINANCIAL_COCKPIT_NAMESPACE}-help-panel-classic-note`,
    access: `${FINANCIAL_COCKPIT_NAMESPACE}-help-panel-access`,
    // Available params: {role}.
    viewingAs: `${FINANCIAL_COCKPIT_NAMESPACE}-help-panel-viewing-as`,
    accessNote: `${FINANCIAL_COCKPIT_NAMESPACE}-help-panel-access-note`,
    help: `${FINANCIAL_COCKPIT_NAMESPACE}-help-panel-help`,
    // The section only a Super Admin sees, and its row opening the network data window.
    superAdmin: `${FINANCIAL_COCKPIT_NAMESPACE}-help-panel-super-admin`,
    networkData: `${FINANCIAL_COCKPIT_NAMESPACE}-help-panel-network-data`,
    networkDataText: `${FINANCIAL_COCKPIT_NAMESPACE}-help-panel-network-data-text`,
    // The WorldWide user's row rebuilding their stored cockpit, its confirmation and outcome.
    recalc: `${FINANCIAL_COCKPIT_NAMESPACE}-help-panel-recalc`,
    recalcText: `${FINANCIAL_COCKPIT_NAMESPACE}-help-panel-recalc-text`,
    // Available params: {date}.
    recalcLast: `${FINANCIAL_COCKPIT_NAMESPACE}-help-panel-recalc-last`,
    // Available params: {date}.
    recalcRunning: `${FINANCIAL_COCKPIT_NAMESPACE}-help-panel-recalc-running`,
    recalcConfirmTitle: `${FINANCIAL_COCKPIT_NAMESPACE}-help-panel-recalc-confirm-title`,
    recalcConfirmText: `${FINANCIAL_COCKPIT_NAMESPACE}-help-panel-recalc-confirm-text`,
    recalcConfirm: `${FINANCIAL_COCKPIT_NAMESPACE}-help-panel-recalc-confirm`,
    // Once the recalculation has ended: the trigger's hover list and the panel's row to load it.
    notifications: `${FINANCIAL_COCKPIT_NAMESPACE}-help-panel-notifications`,
    recalcReady: `${FINANCIAL_COCKPIT_NAMESPACE}-help-panel-recalc-ready`,
    recalcReadyText: `${FINANCIAL_COCKPIT_NAMESPACE}-help-panel-recalc-ready-text`,
    // Available params: {date}.
    recalcReadyAt: `${FINANCIAL_COCKPIT_NAMESPACE}-help-panel-recalc-ready-at`,
    recalcReadyHint: `${FINANCIAL_COCKPIT_NAMESPACE}-help-panel-recalc-ready-hint`,
    recalcRefreshed: `${FINANCIAL_COCKPIT_NAMESPACE}-help-panel-recalc-refreshed`,
    recalcFailed: `${FINANCIAL_COCKPIT_NAMESPACE}-help-panel-recalc-failed`,
  },

  showQuota: {
    label: `${FINANCIAL_COCKPIT_NAMESPACE}-show-quota-label`,
    hideLabel: `${FINANCIAL_COCKPIT_NAMESPACE}-hide-quota-label`,
  },
  geoMapping: {
    label: `${FINANCIAL_COCKPIT_NAMESPACE}-geo-mapping-label`,
  },
  mdfStatus: {
    label: `${FINANCIAL_COCKPIT_NAMESPACE}-mdf-status-label`,
  },
  plannedStatus: {
    label: `${FINANCIAL_COCKPIT_NAMESPACE}-planned-status-label`,
  },
  mandatoryStatus: {
    label: `${FINANCIAL_COCKPIT_NAMESPACE}-mandatory-status-label`, // Mandatory partners
    tooltip: `${FINANCIAL_COCKPIT_NAMESPACE}-mandatory-status-tooltip`,
    // Keyed by TCockpitMandatoryStatus, as greeting.roles is keyed by role id.
    options: {
      All: `${FINANCIAL_COCKPIT_NAMESPACE}-mandatory-status-all`, // All
      Mandatory: `${FINANCIAL_COCKPIT_NAMESPACE}-mandatory-status-mandatory`, // Mandatory
      'Non-Mandatory': `${FINANCIAL_COCKPIT_NAMESPACE}-mandatory-status-non-mandatory`, // Non mandatory
    },
  },
  amplifyMembership: {
    label: `${FINANCIAL_COCKPIT_NAMESPACE}-amplify-membership-label`,
  },
  partnerClass: {
    label: `${FINANCIAL_COCKPIT_NAMESPACE}-partner-class-label`,
  },
  userSelect: {
    placeholder: `${FINANCIAL_COCKPIT_NAMESPACE}-user-select-placeholder`,
  },
  pbm: {
    label: `${FINANCIAL_COCKPIT_NAMESPACE}-pbm-label`,
    all: `${FINANCIAL_COCKPIT_NAMESPACE}-pbm-all`,
  },
  manager: {
    label: `${FINANCIAL_COCKPIT_NAMESPACE}-manager-label`,
    all: `${FINANCIAL_COCKPIT_NAMESPACE}-manager-all`,
  },
  globalPartner: {
    label: `${FINANCIAL_COCKPIT_NAMESPACE}-global-partner-label`,
    all: `${FINANCIAL_COCKPIT_NAMESPACE}-global-partner-all`,
    notPartOfGlobalPartner: `${FINANCIAL_COCKPIT_NAMESPACE}-global-partner-not-part-of`,
  },
  rtm: {
    resellers: `${FINANCIAL_COCKPIT_NAMESPACE}-rtm-resellers`,
    distributors: `${FINANCIAL_COCKPIT_NAMESPACE}-rtm-distributors`,
  },
  filterPanel: {
    title: `${FINANCIAL_COCKPIT_NAMESPACE}-filter-panel-title`, // Filters
    clearAll: `${FINANCIAL_COCKPIT_NAMESPACE}-filter-panel-clear-all`, // Clear all
    geo: `${FINANCIAL_COCKPIT_NAMESPACE}-filter-panel-geo`, // Geo
    partnerSearchPlaceholder: `${FINANCIAL_COCKPIT_NAMESPACE}-filter-panel-partner-search-placeholder`, // Partner name, Partner ID or Location ID
    filterPartners: `${FINANCIAL_COCKPIT_NAMESPACE}-filter-panel-filter-partners`,
    selectPartners: `${FINANCIAL_COCKPIT_NAMESPACE}-filter-panel-select-partners`,
    hideFilters: `${FINANCIAL_COCKPIT_NAMESPACE}-filter-panel-hide-filters`,
    hideList: `${FINANCIAL_COCKPIT_NAMESPACE}-filter-panel-hide-list`,
    resellersShown: `${FINANCIAL_COCKPIT_NAMESPACE}-filter-panel-resellers-shown`,
    distributorsShown: `${FINANCIAL_COCKPIT_NAMESPACE}-filter-panel-distributors-shown`,
    clearSelection: `${FINANCIAL_COCKPIT_NAMESPACE}-filter-panel-clear-selection`,
    searchPlaceholder: `${FINANCIAL_COCKPIT_NAMESPACE}-filter-panel-search-placeholder`,
    selectAll: `${FINANCIAL_COCKPIT_NAMESPACE}-filter-panel-select-all`,
  },
  managerCockpit: {
    noFilteredData: `${FINANCIAL_COCKPIT_NAMESPACE}-manager-no-filtered-data`,
  },
  documentsAndLinks: {
    exportPlan: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-export-plan`,
    exportAs: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-export-as`,
    downloadPlan: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-download-plan`,
    exportMetricSaveError: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-export-metric-save-error`,
    exportMetricConfirmation: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-export-metric-confirmation`,
    exportLoading: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-export-loading`,
    exportErrorTitle: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-export-error-title`,
    exportErrorText: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-export-error-text`,
    exportErrorClose: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-export-error-close`,
    exportFormat: {
      PDF: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-export-pdf`,
      PPTX: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-export-pptx`,
      JSON: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-export-json`,
    },
    exportFormatPdfV2: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-export-pdf-v2`,
    exportContext: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-export-context`, // {partner} · FY{year}
    fullscreen: {
      open: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-fullscreen-open`, // Open fullscreen
      close: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-fullscreen-close`, // Close fullscreen
    },
    treeDocuments: {
      search: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-tree-search`, // Search documents
      expandAll: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-tree-expand-all`, // Expand all
      collapseAll: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-tree-collapse-all`, // Collapse all
      scopeSummary: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-tree-scope-summary`, // {total} documents · {elt} ELT · {qbr} QBR
      groupSummary: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-tree-group-summary`, // {groups} {unit} · {count} documents
      partners: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-tree-partners`, // partners
      creators: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-tree-creators`, // creators
      unknownCreator: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-tree-unknown-creator`, // Unknown creator
    },
    navigation: {
      view: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-navigation-view`, // Navigation view
      drill: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-navigation-drill`, // Rows
      tree: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-navigation-tree`, // Tree
      root: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-navigation-root`, // Everywhere
      search: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-navigation-search`, // Search…
      expand: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-navigation-expand`, // Expand group
      collapse: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-navigation-collapse`, // Collapse group
    },
    grouping: {
      label: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-grouping-label`, // Group by
      ariaLabel: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-grouping-aria-label`, // Group by {grouping}
      geo: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-grouping-geo`, // Geo
      creator: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-grouping-creator`, // Document creator
      partner: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-grouping-partner`, // Partner
    },
    tileTitle: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-title`,
    totalDocuments: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-total-documents`, // Total documents
    createRow: {
      typeLabel: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-create-type-label`,
      typeElt: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-create-type-elt`,
      typeQbr: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-create-type-qbr`,
      eltFormatLabel: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-create-elt-format-label`,
      eltFormatOld: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-create-elt-format-old`,
      eltFormatNew: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-create-elt-format-new`,
      yearLabel: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-create-year-label`,
      quarterLabel: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-create-quarter-label`,
      versionNameLabel: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-create-version-name-label`,
      createButton: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-create-button`,
      rtmUnavailableTooltip: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-create-rtm-unavailable-tooltip`,
    },
    quickActions: {
      viewElt: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-view-elt`,
      viewQbr: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-view-qbr`,
      createElt: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-create-elt`,
      createQbr: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-create-qbr`,
    },
    sectionElt: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-section-elt`,
    sectionQbr: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-section-qbr`,
    sectionLinks: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-section-links`,
    links: {
      sobTrends: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-link-sob-trends`,
      completenessReport: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-link-completeness-report`,
      sobInput: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-link-sob-input`,
      sobResults: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-link-sob-results`,
      financialResults: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-link-financial-results`,
      keyInitiatives: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-link-key-initiatives`,
      generalReports: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-link-general-reports`,
    },
    columns: {
      partnerId: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-column-partner-id`, // Partner ID
      actions: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-column-actions`, // Actions
      name: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-column-name`,
      period: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-column-period`,
      netNdp: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-column-net-ndp`,
      lastModified: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-column-last-modified`,
      modifiedBy: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-column-modified-by`,
      status: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-column-status`,
      format: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-column-format`,
      currency: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-column-currency`,
      offerings: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-column-offerings`,
      legacy: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-column-legacy`,
    },
    legacy: {
      yes: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-legacy-yes`,
      no: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-legacy-no`,
    },
    status: {
      draft: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-status-draft`,
      finalized: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-status-finalized`,
    },
    actions: {
      open: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-action-open`,
      download: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-action-download`,
      downloadDisabledTooltip: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-action-download-disabled-tooltip`,
      delete: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-action-delete`,
      deleteDisabledTooltip: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-action-delete-disabled-tooltip`,
      deleteConfirmTitle: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-action-delete-confirm-title`,
      deleteConfirmMessage: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-action-delete-confirm-message`,
      deleteConfirmButton: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-action-delete-confirm-button`,
      cancel: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-action-cancel`,
    },
    emptyElt: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-empty-elt`,
    emptyQbr: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-empty-qbr`,
    noPartners: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-no-partners`,
    refresh: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-refresh`,
    countSummary: `${FINANCIAL_COCKPIT_NAMESPACE}-documents-and-links-count-summary`,
  },
  pendingActions: {
    priority: `${FINANCIAL_COCKPIT_NAMESPACE}-pending-actions-priority-`,
    category: `${FINANCIAL_COCKPIT_NAMESPACE}-pending-actions-category-`,
    categoryCount: `${FINANCIAL_COCKPIT_NAMESPACE}-pending-actions-category-count`,
    allClearTitle: `${FINANCIAL_COCKPIT_NAMESPACE}-pending-actions-all-clear-title`,
    allClearSubtitle: `${FINANCIAL_COCKPIT_NAMESPACE}-pending-actions-all-clear-subtitle`,
    expandMore: `${FINANCIAL_COCKPIT_NAMESPACE}-pending-actions-expand-more`,
    resolve: `${FINANCIAL_COCKPIT_NAMESPACE}-pending-actions-resolve`,
    ownerTabs: {
      mine: `${FINANCIAL_COCKPIT_NAMESPACE}-pending-actions-owner-tab-mine`,
      role: `${FINANCIAL_COCKPIT_NAMESPACE}-pending-actions-owner-tab-role-`,
      allByRole: `${FINANCIAL_COCKPIT_NAMESPACE}-pending-actions-owner-all-role-`,
      ariaLabel: `${FINANCIAL_COCKPIT_NAMESPACE}-pending-actions-owner-tabs-aria-label`,
    },
    table: {
      actionTitle: `${FINANCIAL_COCKPIT_NAMESPACE}-pending-actions-table-action-title`,
      user: `${FINANCIAL_COCKPIT_NAMESPACE}-pending-actions-table-user`,
      partner: `${FINANCIAL_COCKPIT_NAMESPACE}-pending-actions-table-partner`,
      partnerId: `${FINANCIAL_COCKPIT_NAMESPACE}-pending-actions-table-partner-id`,
      offering: `${FINANCIAL_COCKPIT_NAMESPACE}-pending-actions-table-offering`,
    },
  },
  attentionStatuses: {
    // The `What needs attention` tile. Counters are assembled from a phrase key plus the unit and
    // state words below, so one phrase serves the status, geo and partner levels alike.
    // Available params: {count}, {total}, {unit}, {state}, {severity}.
    counter: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-counter`,
    /** `3 statuses raised` — a level that has no total to count against. */
    raised: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-raised`,
    // The tile's body while the offering in view is switched off.
    switchedOff: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-switched-off`,
    /** What the status list shows, said above it. */
    listIntro: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-list-intro`,
    /** The same, for a level the drill-down walked into; `{unit}` is what that level counts. */
    levelIntro: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-level-intro`,
    rest: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-rest`,
    fullCounter: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-full-counter`,
    score: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-score`,
    severityPriority: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-severity-priority`,
    /** `Top Priority` — the badge the worst level's card carries. The H2 review panel says the
     *  same thing in the same words, so the tile reads that panel's key rather than asking for a
     *  second translation of one phrase. */
    topPriority: 'jbp-h2-review-required-actions-top-priority',
    openLevel: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-open-level`,
    emptyTitle: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-empty-title`,
    /** Said in place of `Nothing needs attention` while the plan in view is not measured full or
     *  not signed: nothing is raised, but the plan is not done either. */
    unfinishedTitle: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-planning-not-completed`,
    /** The plain word a title falls back to where no single offering raised the status — the
     *  catalog's `Offering X` placeholder with nothing of its own to be filled with. */
    offeringGeneric: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-offering-generic`,
    emptyLevel: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-empty-level`,
    /** How the manager cockpit groups the partners behind a status, picked from the tile header. */
    grouping: {
      // What the control is, read out to a screen reader with the grouping in use.
      // Available params: {grouping}.
      ariaLabel: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-grouping-aria-label`,
      /** `Group by` — the word before the grouping's own name on the control. */
      label: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-grouping-label`,
      market: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-grouping-market`,
      pbm: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-grouping-pbm`,
      manager: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-grouping-manager`,
      partner: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-grouping-partner`,
      // Heading of the switcher's menu, naming the level the pick applies to.
      // Available params: {level}.
      applyTo: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-grouping-apply-to`,
    },
    /** Reminding the PBM or the manager a grouped row stands for. */
    reminder: {
      // Available params: {name}.
      remind: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-reminder-remind`,
      // Available params: {name}.
      sent: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-reminder-sent`,
      // Why `Remind PBM` is off: the reminder already went out today. Available params: {names}.
      sentToday: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-reminder-sent-today`,
      success: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-reminder-success`,
      failure: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-reminder-failure`,
      /** A status card's reminder clicked before its sending is available. */
      unavailable: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-reminder-unavailable`,
      /** Why a status card's reminder is off: everyone it reaches was reminded today. */
      blockedRemindedToday: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-reminder-blocked-reminded-today`,
      /** Why a status card's reminder is off: no one it reaches can get a reminder. */
      blockedNoRecipient: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-reminder-blocked-no-recipient`,
      /** Reminds every PBM of a partner at once, from the list its row opens. */
      remindAll: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-reminder-remind-all`,
    },
    /** A manager replacing a partner's PBM with one of their own team, through a change request. */
    replacement: {
      // Available params: {name}.
      replace: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-replacement-replace`,
      // Available params: {name}.
      title: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-replacement-title`,
      back: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-replacement-back`,
      search: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-replacement-search`,
      partners: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-replacement-partners`,
      noTeam: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-replacement-no-team`,
      note: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-replacement-note`,
      cancel: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-replacement-cancel`,
      submit: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-replacement-submit`,
      pending: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-replacement-pending`,
      success: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-replacement-success`,
      failure: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-replacement-failure`,
      alreadyAssigned: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-replacement-already-assigned`,
      notAssigned: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-replacement-not-assigned`,
    },
    /** The tile opened over the whole screen: a navigator of people or places, and the partners. */
    fullscreen: {
      open: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-fullscreen-open`,
      close: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-fullscreen-close`,
      expand: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-fullscreen-expand`,
      collapse: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-fullscreen-collapse`,
      empty: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-fullscreen-empty`,
      allClear: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-fullscreen-all-clear`,
      /** How the navigator lists the partners in view. */
      modes: {
        people: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-fullscreen-mode-people`,
        geo: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-fullscreen-mode-geo`,
        managers: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-fullscreen-mode-managers`,
        pbms: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-fullscreen-mode-pbms`,
        partners: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-fullscreen-mode-partners`,
      },
      /** The navigator's search field, by mode. */
      find: {
        people: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-fullscreen-find-people`,
        geo: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-fullscreen-find-geo`,
        managers: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-fullscreen-find-managers`,
        pbms: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-fullscreen-find-pbms`,
        partners: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-fullscreen-find-partners`,
      },
      /** The navigator's first row, standing for everything in view. */
      root: {
        people: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-fullscreen-root-people`,
        geo: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-fullscreen-root-geo`,
        managers: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-fullscreen-root-people`,
        pbms: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-fullscreen-root-people`,
        partners: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-fullscreen-root-partners`,
      },
      myPbms: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-fullscreen-my-pbms`,
      otherManagers: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-fullscreen-other-managers`,
      // Available params: {count}, {total}.
      partnersWithOpen: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-fullscreen-partners-with-open`,
      // Available params: {scope}.
      openByStatus: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-fullscreen-open-by-status`,
      // Available params: {scope}.
      topPbms: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-fullscreen-top-pbms`,
      // Available params: {count}.
      openCount: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-fullscreen-open-count`,
      columns: {
        partner: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-fullscreen-column-partner`,
        pbm: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-fullscreen-column-pbm`,
        manager: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-fullscreen-column-manager`,
        open: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-fullscreen-column-open`,
        severity: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-fullscreen-column-severity`,
      },
    },
    /** The control that narrows the grouped level to what the reader is looking for. */
    search: {
      ariaLabel: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-search-aria-label`,
      /** Said inside the field while it is empty, by what the level lists. */
      placeholderPartner: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-search-placeholder-partner`,
      placeholderPbm: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-search-placeholder-pbm`,
      placeholderManager: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-search-placeholder-manager`,
      clear: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-search-clear`,
    },
    breadcrumb: {
      allStatuses: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-breadcrumb-all-statuses`,
      ariaLabel: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-breadcrumb-aria-label`,
    },
    /** Singular and plural of everything a level counts. */
    units: {
      status: {
        one: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-unit-status`,
        many: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-unit-statuses`,
      },
      partner: {
        one: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-unit-partner`,
        many: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-unit-partners`,
      },
      market: {
        one: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-unit-market`,
        many: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-unit-markets`,
      },
      cluster: {
        one: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-unit-cluster`,
        many: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-unit-clusters`,
      },
      country: {
        one: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-unit-country`,
        many: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-unit-countries`,
      },
      geo: {
        one: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-unit-geo`,
        many: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-unit-geos`,
      },
      pbm: {
        one: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-unit-pbm`,
        many: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-unit-pbms`,
      },
      manager: {
        one: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-unit-manager`,
        many: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-unit-managers`,
      },
    },
    /** Past participle the counters close on: statuses are raised, groups are affected. */
    states: {
      raised: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-state-raised`,
      affected: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-state-affected`,
      /** The manager cockpit's partners, counted once each under the robot. */
      needAttention: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-state-need-attention`,
    },
    detail: {
      status: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-detail-status`,
      partner: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-detail-partner`,
      condition: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-detail-condition`,
      score: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-detail-score`,
      note: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-detail-note`,
      alsoRaised: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-detail-also-raised`,
      alsoRaisedForPartner: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-detail-also-raised-for-partner`,
      /** A section scoped per offering, opened for a partner that shows none. */
      noOffering: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-detail-no-offering`,
      /** The card's own menu, where every action but the leading one is kept. */
      moreActions: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-detail-more-actions`,
    },
    completeness: {
      notMeasured: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-completeness-not-measured`,
      /** Heads the completeness rows the tile shows in place of `Nothing needs attention` once
       *  the plan is clean. */
      overviewTitle: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-completeness-overview-title`,
      /** The plate above the rows: how far the plan is, and whether the PBM has signed it. */
      total: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-completeness-total`,
      sections: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-completeness-sections`,
      // How many sections are finished, stated beside the `Sections` header.
      // Available params: {count}, {total}.
      sectionsCount: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-completeness-sections-count`,
      /** Said on pointing at a section bar: the whole bar opens that section. */
      openSectionHint: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-completeness-open-section-hint`,
      // The `{date}` param is the acknowledgment date, e.g. `12 Mar 2026`.
      signed: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-completeness-signed`,
      notSigned: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-completeness-not-signed`,
      notSignedDistributor: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-completeness-not-signed-distributor`,
      /** Full completeness without a signature: the plan still is not finished. */
      notSignedWarning: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-completeness-not-signed-warning`,
      /** Why the plan is not signed yet, said under the signature state. The PBM reads when signing
       *  opens; everyone else reads who signs and when. */
      signReady: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-completeness-sign-ready`,
      signOpensAt: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-completeness-sign-opens-at`,
      signWaiting: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-completeness-sign-waiting`,
      signPbmLater: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-completeness-sign-pbm-later`,
      /** The same two for a distributor, whose plan is signed by its DBM. */
      signWaitingDistributor: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-completeness-sign-waiting-distributor`,
      signPbmLaterDistributor: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-completeness-sign-pbm-later-distributor`,
      /** The lead sentence of the detail on `Overall`, where every programme is listed. */
      overallIntro: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-completeness-overall-intro`,
      /** Follows the focused programme's name over its signers on `Overall`. */
      signaturesTitle: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-completeness-signatures-title`,
      noSigners: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-completeness-no-signers`,
    },
    finSobQuality: {
      /** The plate above the pillars: the plan's score and the line it is read against. */
      score: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-finsob-quality-score`,
      // The `{threshold}` param is the score a plan is expected to reach, e.g. `80`.
      threshold: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-finsob-quality-threshold`,
      // Available params: {points}, {threshold}.
      gap: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-finsob-quality-gap`,
      /** The score sits exactly on the line. */
      atThreshold: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-finsob-quality-at-threshold`,
      // The `{threshold}` param, as above; said when the score already clears the line.
      met: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-finsob-quality-met`,
      notMeasured: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-finsob-quality-not-measured`,
      noCategories: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-finsob-quality-no-categories`,
    },
    initiativesQuality: {
      total: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-initiatives-quality-total`,
      // The `{threshold}` param is the score an initiatives plan is expected to reach.
      threshold: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-initiatives-quality-threshold`,
      // The plate's own line under the score; the `{threshold}` param is the score to reach.
      required: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-initiatives-quality-required`,
      /** A pillar the calculation skipped — no business priority to measure it against. */
      notScored: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-initiatives-quality-not-scored`,
      notMeasured: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-initiatives-quality-not-measured`,
    },
    mdf: {
      // What the big number counts; the `{year}` param is the plan's fiscal year.
      initiatives: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-mdf-initiatives`,
      // The same count read against the whole plan; the `{total}` param is the plan's size.
      ofTotal: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-mdf-of-total`,
      // The plan holds no initiatives at all; the `{year}` param, as above.
      noPlan: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-mdf-no-plan`,
      /** Why the card records no justification: nothing stores one yet. */
      justificationNote: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-mdf-justification-note`,
    },
    sobActuals: {
      categories: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-sob-categories`,
      empty: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-sob-empty`,
      /** `Category` — the table's first column. */
      category: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-sob-category`,
      /** `Plan` — the plan's SOB for the year. */
      plan: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-sob-plan`,
      /** `Missing` — a quarter up to the collected one with no SOB figure. */
      missing: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-sob-missing`,
      /** `Locked` — a category the server keeps closed until another action is done. */
      locked: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-sob-locked`,
    },
    // The top next steps every status of the single-partner tile lists under its own line.
    nextSteps: {
      /** `Details` — the way into the status' own detail. */
      details: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-next-steps-details`,
      /** `See details` — a step that opens the status' detail, for a row the reader cannot act on. */
      seeDetails: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-next-steps-see-details`,
      /** `Open section` — a step that opens its plan section, not the status' detail. */
      openSection: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-next-steps-open-section`,
      /** `Open {Offering}` — a signature the server holds until another offering's plan is complete. Params: {Offering}. */
      openOffering: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-next-steps-open-offering`,
      /** `Complete plan` — a partner's step on the manager cockpit: its plan is not complete. */
      completePlan: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-next-steps-complete-plan`,
      /** `Open plan` — opens the partner's plan in a new tab beside a step that reminds its PBM. */
      openPlan: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-next-steps-open-plan`,
      /** `Submit SOB` — a partner's step on the manager cockpit: its SOB actuals are missing. */
      submitSob: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-next-steps-submit-sob`,
      /** `+{count} more` — steps the line leaves out. Params: {count}. */
      more: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-next-steps-more`,
      /** `Nothing to list here — open the details.` — a status with no steps of its own. */
      none: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-next-steps-none`,
      /** `{percent}% complete` — a plan section's figure. Params: {percent}. */
      sectionPercent: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-next-steps-section-percent`,
      /** `Acknowledge the plan` — a full plan the PBM has still to sign. */
      signPlan: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-next-steps-sign-plan`,
      /** `Every section is complete` — why the plan waits only for its signature. */
      allSectionsComplete: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-next-steps-all-sections-complete`,
      /** `Pending acknowledgment from {SignerName} {SignerPost}` — a signer the plan waits for. Params: {SignerName}, {SignerPost}. */
      pendingAcknowledgment: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-next-steps-pending-acknowledgment`,
      /** `Remind` — a reminder to the signer the plan is waiting for. */
      remind: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-next-steps-remind`,
      /** `Reminded today` — the signer was reminded today and cannot be again until tomorrow. */
      remindedToday: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-next-steps-reminded-today`,
      // The word a manager cockpit step's button says before its icon; the tooltip keeps the act.
      short: {
        /** `Plan` — opens the partner's plan. */
        plan: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-next-steps-short-plan`,
        /** `SOB` — enters the partner's SOB actuals. */
        sob: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-next-steps-short-sob`,
        /** `Review` — opens the plan's quality review. */
        review: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-next-steps-short-review`,
        /** `Initiative` — creates an initiative. */
        initiative: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-next-steps-short-initiative`,
        /** `Justify` — gives the quarter plan its justification. */
        justify: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-next-steps-short-justify`,
        /** `Details` — opens the status' detail. */
        details: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-next-steps-short-details`,
        /** `Sign` — acknowledges the plan. */
        sign: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-next-steps-short-sign`,
        /** `Remind` — reminds the PBM or the signer. */
        remind: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-next-steps-short-remind`,
      },
    },
    h2Review: {
      noItems: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-h2-review-no-items`,
    },
    programRisk: {
      title: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-program-risk-title`,
      columnProgram: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-program-risk-column-program`,
      columnMembership: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-program-risk-column-membership`,
      columnRequired: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-program-risk-column-required`,
      amplifyTrack: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-program-risk-amplify-track`,
      amplifyImpact: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-program-risk-amplify-impact`,
      growthPlay: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-program-risk-growth-play`,
      eligible: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-program-risk-eligible`,
      member: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-program-risk-member`,
      /** What the payload does not carry, said instead of the list the sheet asks for. */
      requirementsUnknown: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-program-risk-requirements-unknown`,
      noPrograms: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-program-risk-no-programs`,
    },
    quarterPlan: {
      // The sentence above the list; the `{period}` param names the period measured.
      caption: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-quarter-plan-caption`,
      categories: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-quarter-plan-categories`,
      // Available params: {count}, {total}.
      count: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-quarter-plan-count`,
      /** The share of plan a category reached, as the last column is titled. */
      achievement: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-quarter-plan-achievement`,
      /** The period still has an open quarter, so no actuals stand against the plan yet. */
      periodOpen: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-quarter-plan-period-open`,
      /** The word the caption uses for the year-to-date period. */
      periodYtd: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-quarter-plan-period-ytd`,
      // Every category reached its plan; the `{period}` param, as above.
      allAchieved: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-quarter-plan-all-achieved`,
      noData: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-quarter-plan-no-data`,
    },
  },
}
